import React, { FC } from "react";
import { Box } from "@mui/material";
import { PropertiesCard } from "shared-ts-ui-properties-card";
import { Formik } from "formik";
import { FormikHelpers } from "formik/dist/types";
import {
  Fireplace,
  FireplaceUpdateSpec,
  useFireplaceDao,
} from "firefly-my-chimney-ts-building";
import { useTranslation } from "react-i18next";
import { CustomerEnvironmentId } from "firefly-shared-ts-customer-environment";
import { Button } from "@mui/material";
import { Property } from "shared-ts-property";

export interface FireplaceFormValues {
  name: string;
}
export interface FireplaceFormProps {
  environment: CustomerEnvironmentId;
  fireplace: Fireplace;
  onChange: (update: FireplaceUpdateSpec) => void;
}
export const FireplaceForm: FC<FireplaceFormProps> = (props) => {
  const { fireplace, environment } = props;
  const { t } = useTranslation("my-chimney-ts-translations");
  const { t: tSharedDomain } = useTranslation("firefly-shared-ts-domain");
  const fireplaceDao = useFireplaceDao(environment);
  const formInitialValues: FireplaceFormValues = {
    name: fireplace.mcFields?.name ?? "",
  };
  const handleSubmit = async (
    values: FireplaceFormValues,
    formikHelpers: FormikHelpers<FireplaceFormValues>
  ) => {
    const update: FireplaceUpdateSpec = {
      type: "FireplaceUpdateSpec",
      chimneyId: fireplace.flue!.chimney!.id,
      flueId: fireplace.flue!.id,
      id: fireplace.id,
      securityToken: fireplace.securityToken,
      name: { value: values.name.notEmptyOrNull() },
    };
    await fireplaceDao.update(update);
    props.onChange(update);
  };

  return (
    <Box>
      <Formik
        initialValues={formInitialValues}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({
          dirty,
          values,
          errors,
          resetForm,
          submitForm,
          isSubmitting,
          setFieldValue,
        }) => {
          const handleSaveClick = () => {
            return submitForm();
          };

          return (
            <Box>
              <PropertiesCard
                elevation={0}
                header={{
                  title: t("Your Settings"),
                }}
              >
                <Property
                  label={tSharedDomain("Name")}
                  name={"name"}
                  value={values.name}
                  mode={"edit"}
                  helperText={t("Your name on the fireplace")}
                  onChange={(value, name) => setFieldValue(name, value)}
                />
              </PropertiesCard>
              <Button
                color={"secondary"}
                variant={"outlined"}
                disabled={!dirty}
                loading={isSubmitting}
                onClick={handleSaveClick}
              >
                {t("Save")}
              </Button>
            </Box>
          );
        }}
      </Formik>
    </Box>
  );
};
